<app-loader [isLoading]="isLoading" loaderText="Cargando certificado"></app-loader>
<div mat-dialog-content role="dialog" aria-modal="true" aria-labelledby="p12-modal-title" aria-describedby="p12-modal-description">
  <!-- Header con icono y título -->
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <img src="assets/icons/signature-icon.svg" alt="Icono de firma digital" class="header-icon-img" />
    </div>
    <h3 id="p12-modal-title">Elegir P10</h3>
    <p id="p12-modal-description" class="sr-only">Selecciona su archivo de certificado PKCS10 (.p10 o .pfx) y luego escriba la contraseña de su certificado digital.</p>
  </div>

  <!-- Contenido principal -->
  <div class="dialog-body">
    <!-- Descripción -->
    <p class="dialog-description">Selecciona su archivo de certificado PKCS10 (.p10 o .pfx) y luego escriba la contraseña de su certificado digital.</p>

    <!-- Upload Container -->
    <div class="upload-container">
      <div
        class="drop-zone"
        [class.has-files]="selectedFile"
        [class.drop-zone--drag]="isDragActive"
        (click)="signatureFileInput.click()"
        role="button"
        tabindex="0"
        cdkFocusInitial
        (keydown.enter)="signatureFileInput.click()"
        (keydown.space)="signatureFileInput.click(); $event.preventDefault()"
        (dragenter)="onDragEnter($event)"
        (dragleave)="onDragLeave($event)"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)">

        <!-- Estado vacío: Sin archivo -->
        <div *ngIf="!selectedFile" class="drop-zone-empty">
          <div class="drop-zone-icon">
            <img src="assets/icons/upload-icon.svg" alt="Upload" class="drop-zone-icon-img" />
          </div>
          <div class="drop-zone-text">Arrastra archivos aquí o haz clic para seleccionar</div>
        </div>

        <!-- Estado con archivo: Mostrar archivo dentro del drop zone -->
        <div *ngIf="selectedFile" class="drop-zone-filled">
          <div class="file-item-inline">
            <div class="file-icon-inline">
              <i class="fas fa-file-certificate"></i>
            </div>
            <div class="file-info-inline">
              <div class="file-name-inline">{{ selectedFile.name }}</div>
              <div class="file-size-inline">{{ formatFileSize(selectedFile.size) }}</div>
            </div>
            <button
              class="file-remove-inline"
              (click)="clearFile(signatureFileInput); $event.stopPropagation()"
              type="button"
              aria-label="Eliminar archivo">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <input
          #signatureFileInput
          id="signatureFile"
          type="file"
          (change)="onFileSelected($event)"
          accept=".p10,.pfx"
          aria-label="Seleccionar archivo de certificado PKCS10"
          aria-describedby="certificate-file-help"
          aria-required="true"
          class="file-input" />
        <span id="certificate-file-help" class="sr-only">Seleccione un archivo de certificado en formato .p10 o .pfx</span>
      </div>
    </div>

    <!-- Contraseña (estilo estándar auth / Certifirma Digital Físico) -->
    <label for="certificate-password" class="label-document">Contraseña del certificado *</label>
    <div class="auth-input-wrap auth-input-wrap-password">
      <input
        type="text"
        id="certificate-password"
        [(ngModel)]="password"
        name="password"
        class="auth-input"
        [class.auth-input-masked]="!passwordVisible"
        placeholder="Ingrese la contraseña del certificado"
        aria-required="true"
        aria-describedby="certificate-password-help"
        autocomplete="off"
        [attr.aria-label]="passwordVisible ? 'Contraseña visible' : 'Contraseña oculta'" />
      <button
        type="button"
        class="password-toggle-btn"
        (mousedown)="passwordVisible = true"
        (mouseup)="passwordVisible = false"
        (mouseleave)="passwordVisible = false"
        tabindex="-1"
        [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
        <i class="fas fa-eye" aria-hidden="true"></i>
      </button>
      <span id="certificate-password-help" class="sr-only">Ingrese la contraseña del archivo de certificado seleccionado</span>
    </div>

    <label for="certificate-password-confirm" class="label-document">Confirmar contraseña del certificado *</label>
    <div class="auth-input-wrap auth-input-wrap-password">
      <input
        type="text"
        id="certificate-password-confirm"
        [(ngModel)]="passwordConfirm"
        name="passwordConfirm"
        class="auth-input"
        [class.auth-input-masked]="!confirmPasswordVisible"
        placeholder="Repita la contraseña del certificado"
        aria-required="true"
        autocomplete="off"
        [attr.aria-label]="confirmPasswordVisible ? 'Confirmación visible' : 'Confirmación oculta'" />
      <button
        type="button"
        class="password-toggle-btn"
        (mousedown)="confirmPasswordVisible = true"
        (mouseup)="confirmPasswordVisible = false"
        (mouseleave)="confirmPasswordVisible = false"
        tabindex="-1"
        [attr.aria-label]="'Mantenga pulsado para ver la confirmación'">
        <i class="fas fa-eye" aria-hidden="true"></i>
      </button>
    </div>
    <p class="validation-message" *ngIf="passwordConfirm && password !== passwordConfirm">
      Las contraseñas no coinciden.
    </p>
  </div>

  <!-- Botones de acción -->
  <div class="actions">
    <button
      class="btn btn-secondary"
      (click)="onCancel()"
      type="button"
      [disabled]="isLoading"
      [attr.aria-disabled]="isLoading"
      aria-label="Cancelar carga de certificado y cerrar modal">
      Volver
    </button>
    <button
      class="btn btn-primary"
      (click)="onSubmit()"
      [disabled]="!canSubmit || isLoading"
      type="button"
      [attr.aria-label]="canSubmit ? 'Firmar documentos con certificado cargado' : 'Seleccione un certificado y escriba ambas contraseñas para continuar'"
      [attr.aria-disabled]="!canSubmit || isLoading">
      Firmar documento
    </button>
  </div>
</div>
